<div class="col-span-full bg-transparent overflow-hidden">

  <!-- Mini-grid preview body (mock of the customize layout popup with live width stepper) -->
  <div class="p-4 sm:p-6 bg-[#FAFAFE] dark:bg-slate-950/40">
    <div cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="onTileDrop($event)"
      [ngClass]="unifiedGridClass">

      <div *ngFor="let tile of previewTiles(); trackBy: trackTile" cdkDrag [cdkDragData]="tile"
        [cdkDragDisabled]="tile.visible === false" [ngClass]="[
          getPreviewTileClass(tile),
          tile.visible === false
            ? 'border-dashed border-slate-300 dark:border-slate-600 opacity-60 cursor-not-allowed'
            : 'border-slate-200 dark:border-slate-700 shadow-sm cursor-grab active:cursor-grabbing hover:shadow-lg hover:-translate-y-0.5 hover:border-[#AD46FF]/40'
        ]"
        class="layout-editor-tile group relative rounded-xl border bg-white dark:bg-slate-800 transition-all duration-200 overflow-hidden">

        <!-- Drop placeholder — highlights the slot the card will land in. -->
        <div *cdkDragPlaceholder [ngClass]="getPreviewTileClass(tile)"
          class="rounded-xl border-2 border-dashed border-[#AD46FF]/60 bg-violet-50 dark:bg-violet-500/10 min-h-[88px]">
        </div>

        <!-- Tile header: drag handle + title + source chip -->
        <div class="flex items-start justify-between gap-2 px-3 pt-2.5 pb-1.5">
          <div class="flex items-center justify-between gap-1.5 min-w-0">
            <span class="text-slate-300 dark:text-slate-600 group-hover:text-[#AD46FF] transition-colors shrink-0"
              title="Drag to reorder">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="9" cy="5" r="1" fill="currentColor" stroke="none" />
                <circle cx="9" cy="12" r="1" fill="currentColor" stroke="none" />
                <circle cx="9" cy="19" r="1" fill="currentColor" stroke="none" />
                <circle cx="15" cy="5" r="1" fill="currentColor" stroke="none" />
                <circle cx="15" cy="12" r="1" fill="currentColor" stroke="none" />
                <circle cx="15" cy="19" r="1" fill="currentColor" stroke="none" />
              </svg>
            </span>
            <span class="text-[11px] sm:text-[12px] font-semibold text-[#141437] dark:text-white truncate"
              [title]="tile.title">
              {{ tile.title }}
            </span>
          </div>
          <div class="flex items-center gap-3 flex-wrap">

            <!-- Source chip: which report this tile comes from -->
            <span class="text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-md shrink-0" [ngClass]="tile.source === 'MO'
                  ? 'bg-blue-50 text-blue-600 border border-blue-200/60 dark:bg-blue-500/10 dark:text-blue-300 dark:border-blue-500/30'
                  : 'bg-violet-50 text-[#AD46FF] border border-[#AD46FF]/20 dark:bg-violet-500/10'">
              {{ tile.source }}
            </span>
          </div>
        </div>

        <!-- Tile body: scaled-down preview placeholder + width stepper -->
        <div class="px-3 pb-3">
          <div
            class="rounded-lg bg-gradient-to-br from-violet-50 via-white to-violet-50/50 dark:from-violet-500/10 dark:via-slate-800 dark:to-violet-500/5 border border-slate-100 dark:border-slate-700/50 h-14 sm:h-16 flex items-center justify-center mb-2 overflow-hidden relative">
            <div class="flex items-end gap-1 w-2/3 h-1/2 opacity-70">
              <span class="flex-1 bg-[#AD46FF]/30 rounded-sm" style="height: 40%"></span>
              <span class="flex-1 bg-[#AD46FF]/50 rounded-sm" style="height: 70%"></span>
              <span class="flex-1 bg-[#AD46FF]/40 rounded-sm" style="height: 55%"></span>
              <span class="flex-1 bg-[#AD46FF]/60 rounded-sm" style="height: 90%"></span>
              <span class="flex-1 bg-[#AD46FF]/35 rounded-sm" style="height: 50%"></span>
              <span class="flex-1 bg-[#AD46FF]/55 rounded-sm" style="height: 80%"></span>
            </div>
            <span class="absolute top-0.5 right-1 text-[9px] font-semibold text-[#AD46FF]/70 uppercase tracking-wider">
              {{ tile.colSpan }}/12
            </span>
          </div>

          <!-- Bottom toolbar: width stepper (left) + remove action (right) -->
          <div class="flex items-center justify-between gap-2 flex-wrap">
            <!-- Width stepper: minimize-2 / label / maximize-2 — same as MR1 popup -->
            <div class="flex items-center gap-1.5">
              <span class="text-[10px] font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wide mr-0.5">
                Width
              </span>

              <!-- Decrease (minimize-2) -->
              <button type="button" (click)="decreaseColSpan(tile.id); $event.stopPropagation()"
                [disabled]="!canDecreaseColSpan(tile)" class="p-1 rounded-md border transition-all"
                [ngClass]="canDecreaseColSpan(tile)
                  ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                  : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'" title="Decrease width">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="4 14 10 14 10 20" />
                  <polyline points="20 10 14 10 14 4" />
                  <line x1="14" y1="10" x2="21" y2="3" />
                  <line x1="3" y1="21" x2="10" y2="14" />
                </svg>
              </button>

              <!-- Current width pill — Small / Medium / Large / Full -->
              <span
                class="inline-flex items-center justify-center min-w-[58px] h-[20px] px-2 rounded-md text-[10px] font-semibold bg-[#AD46FF]/10 text-[#AD46FF] border border-[#AD46FF]/20 select-none whitespace-nowrap">
                {{ getColSpanLabel(tile.colSpan) }}
              </span>

              <!-- Increase (maximize-2) -->
              <button type="button" (click)="increaseColSpan(tile.id); $event.stopPropagation()"
                [disabled]="!canIncreaseColSpan(tile)" class="p-1 rounded-md border transition-all"
                [ngClass]="canIncreaseColSpan(tile)
                  ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                  : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'" title="Increase width">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="15 3 21 3 21 9" />
                  <polyline points="9 21 3 21 3 15" />
                  <line x1="21" y1="3" x2="14" y2="10" />
                  <line x1="3" y1="21" x2="10" y2="14" />
                </svg>
              </button>
            </div>

            <!-- Remove action: text + icon pill button matching the width pill design -->
            <button type="button" (click)="deleteTile(tile.id); $event.stopPropagation()"
              class="inline-flex items-center gap-1 h-[22px] px-2 rounded-md text-[10px] font-semibold bg-red-50 text-red-600 border border-red-200/70 hover:bg-red-100 hover:border-red-300 hover:text-red-700 dark:bg-red-500/10 dark:text-red-300 dark:border-red-500/30 dark:hover:bg-red-500/20 dark:hover:text-red-200 transition-all whitespace-nowrap shrink-0"
              title="Remove from dashboard">
              <app-icon-v2 name="trash" [size]="12"></app-icon-v2>
              <span class="uppercase tracking-wide">Remove</span>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>